
declare const gtag: Function
import Vue from "vue";
import partnersStore from "@/state/modules/partners";

interface ProfileDropdownData {
	hideUserMenu: boolean;
}
export default Vue.extend({
	name: "ProfileDropdown",
	props: {
		user: Object,
		userManagerUrl: String,
		theme: String,
		showUserTab: {
			type: Boolean,
			default: false,
		},
		showPartnerTab: {
			type: Boolean,
			default: false,
		},
		showStyleGuideTab: {
			type: Boolean,
			default: false,
		},
	},
	data(): ProfileDropdownData {
		return {
			hideUserMenu: true,
		};
	},
	computed: {
		userPartner() {
			return partnersStore.state.userPartner;
		},
		isProd() {
			return process.env.NODE_ENV === 'production'
		}
	},
	methods: {
		onCloseUserMenu() {
			if (!this.hideUserMenu) {
				this.hideUserMenu = true;
			}
			gtag('event', 'close', { 'event_category': 'ProfileDropdown', 'event_label': 'ProfileDropdown'});
		},
		toggleUserMenu() {
			this.hideUserMenu = !this.hideUserMenu;
			gtag('event', 'toggle', { 'event_category': 'ProfileDropdown', 'event_label': 'ProfileDropdown'});
		},
		swapTheme() {
			this.$emit("swapTheme");
			gtag('event', 'swapTheme', { 'event_category': 'ProfileDropdown', 'event_label': 'ProfileDropdown'});
			this.onCloseUserMenu();
		},
		logout() {
			this.$emit("logout");
			gtag('event', 'logout', { 'event_category': 'ProfileDropdown', 'event_label': 'ProfileDropdown'});
		},
	},
});
